import { toRefs, ref, onMounted } from 'vue';
import { useVideoWatchTracking } from './component-lib.esm27.js';
import { useFacebookSdk } from '../../compositions/component-lib.esm2.js';
import { useMounted } from '../../compositions/component-lib.esm12.js';
import { defaultWindow } from '../../utils/component-lib.esm2.js';
import { EVENTS } from '../../config/component-lib.esm.js';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    trackVideoPlayEvents: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      trackVideoPlayEvents
    } = toRefs(props);
    const fbWrapperRef = ref(null);
    const window = defaultWindow;
    const isMounted = useMounted();
    const player = ref(null);
    const videoStarted = ref(false);
    const {
      track,
      stop
    } = useVideoWatchTracking(event => emit('event', event), {
      getDuration: async () => player.value.getDuration(),
      getCurrentTime: async () => player.value.getCurrentPosition(),
      trackPlaying: trackVideoPlayEvents.value
    });
    function parseVideo(FB) {
      if (fbWrapperRef.value) {
        FB.XFBML.parse(fbWrapperRef.value);
        FB.Event.subscribe('xfbml.ready', msg => {
          if (msg.type === 'video') {
            player.value = msg.instance;
            subscribe();
            if (isMounted.value) setTimeout(() => {
              emit('loaded');
            }, 500);
          }
        });
      }
    }
    function subscribe() {
      player.value.subscribe('startedPlaying', () => {
        if (!videoStarted.value) emit('event', EVENTS.VIDEO_STARTED);
        if (!trackVideoPlayEvents.value) emit('event', EVENTS.VIDEO_PLAYING);
        videoStarted.value = true;
        track();
      });
      player.value.subscribe('paused', () => {
        emit('event', EVENTS.VIDEO_PAUSED);
        stop();
      });
      player.value.subscribe('finishedPlaying', () => {
        emit('event', EVENTS.VIDEO_ENDED);
        stop();
      });
    }
    useFacebookSdk(parseVideo);
    onMounted(() => {
      if (window && window.FB) parseVideo(window.FB);
    });
    return {
      fbWrapperRef
    };
  }
};
export { script as default };